// components
import { IconButton } from '@sdb/planning-ui';
import { StyledBoxFlexCenter } from 'components/shared/Box/Box.styles';
import {
  StyledShimmeredTypographyBold,
  StyledTypographyLineClamped
} from 'components/shared/Typography/Typography.styles';
import { StyledSettingsListItem } from './FlexMatchDrawerSettings.styles';

// hooks
import { useSortable } from '@dnd-kit/sortable';

// types
import { SortableStepRowProps } from './FlexMatchDrawerSettings.types';

// utils
import { CSS } from '@dnd-kit/utilities';
import { useFormContext } from 'react-hook-form';
import { StyledListItemText } from './SortableStepRow.styles';

export const SortableStepRow = ({
  step,
  isCurrent,
  onSelect,
  onDelete
}: SortableStepRowProps) => {
  const { watch } = useFormContext();
  const stepName = watch(`stepName`);

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: step.id! });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 2 : 1,
    opacity: isDragging ? 0.9 : 1
  } as const;

  return (
    <StyledBoxFlexCenter ref={setNodeRef} style={style}>
      <IconButton
        ref={setActivatorNodeRef}
        {...attributes}
        {...listeners}
        type="grip-dots-vertical"
        color="secondary"
        aria-label="Reorder step"
      />

      <StyledSettingsListItem
        disableGutters
        onClick={onSelect}
        secondaryAction={
          <IconButton
            type="trash-can"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          />
        }
        currentStep={isCurrent ? step : undefined}
        step={step}
      >
        <StyledListItemText
          primary={
            step.name === '' ? (
              <StyledShimmeredTypographyBold component="span">
                {stepName}
              </StyledShimmeredTypographyBold>
            ) : (
              <StyledTypographyLineClamped lineClamp={1} component="span">
                {step.name}
              </StyledTypographyLineClamped>
            )
          }
        />
      </StyledSettingsListItem>
    </StyledBoxFlexCenter>
  );
};
